// src/api/address.api.js
import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";
import { toast } from "react-toastify";

/** Obtener direcciones de un paciente */
export const getAddresses = async (id) => {
  try {
    const res = await request(API_ROUTES.getGeneralData("Address", id), { method: "GET" });
    const data = await res.json();

    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return [];
    }

    return data.data || [];
  } catch (err) {
    console.error("Error al cargar direcciones:", err);
    return [];
  }
};

/** Crear dirección */
export const saveAddress = async (payload) => {
  try {
    const isUpdate = !!payload.id;
    const res = await request(API_ROUTES.saveAddress, {
      method: isUpdate ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return false;
    }

    return data;
  } catch (err) {
    console.error("Error al guardar dirección:", err);
    throw err;
  }
};

/** Inactivar dirección */
export const deactivateAddress = async (id) => {
  try {
    const res = await request(API_ROUTES.updateGeneralData, {
      method: "PUT",
      body: JSON.stringify({ id, tipo: "Address" }),
    });

    const data = await res.json();

    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return false;
    }

    return true;
  } catch (err) {
    console.error("Error al eliminar dirección:", err);
    return false;
  }
};
